import { render, staticRenderFns } from "./VerticalMenuItem.vue?vue&type=template&id=edaeada2&"
import script from "./VerticalMenuItem.vue?vue&type=script&lang=js&"
export * from "./VerticalMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports